import React, { useState, useRef, useMemo } from 'react';
import Preview from './preview';
import { Layout, Tabs } from 'tea-component';
import { connect, useHistory } from 'umi';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { debounce } from 'throttle-debounce';
import { specialReport, specialReportIds } from './constant';
import ContentBody from '@/pages/opinion/components/ContentBody';
import usePageName from '@op/hooks/usePageName';
import './styles/markdown-preview.scss';
import './styles/index.scss'; 
const { Content, Body } = Layout;

function Gpt({ gameInfo, wholeGameInfo, listMenu }: any) {
  const history = useHistory();

  const { kind, name } = history?.location?.query; 

  const { pageName } = usePageName({ listMenu, name });

  const [tabs, setTabs] = useState<any>([]);
  const [activeId, setActiveId] = useState(kind);
  const contentRef = useRef<HTMLElement>(null);

  const { formatMessage } = useLanguage();

  const debounceTime = 100;

  const [scrolling, setScrolling] = useState(false);

  const specialReportList = useMemo(() => {
    const { edition_unified_id } = gameInfo;
    return specialReport[edition_unified_id];
  }, [gameInfo]);

  const isCustom = useMemo(() => {
    return !specialReportIds.includes(activeId);
  }, [activeId]);

  return (
    <Layout>
      <Body className="markdown-preview-wrapper stats">
        <Content
          className="dbo-gpt dbo-markdown markdown-preview"
          ref={contentRef}
          onScrollCapture={debounce(100, () => {
            setScrolling(true);
            setTimeout(() => {
              setScrolling(false);
            }, debounceTime);
          })}
        >
          <ContentBody
            contentHeard={
              <Content.Header
                className="dbo-header contentHead-normal"
                title={formatMessage({
                  id: pageName
                    ? decodeURIComponent(pageName)
                    : 'GPT Auto Report',
                })}
              >
                <div className="header-tab">
                  <Tabs
                    ceiling
                    tabs={tabs.map((item: any) => ({
                      ...item,
                      label: formatMessage({ id: item.label }),
                    }))}
                    activeId={activeId}
                    onActive={(tab) => {
                      console.log(tab.id);
                      setActiveId(tab.id);
                    }}
                  ></Tabs>
                </div>
              </Content.Header>
            }
            className={`dbo-markdown-preview dbo-markdown-preview-${
              isCustom ? 'custom' : 'not-custom'
            }`}
          >
            <Preview
              custom={isCustom} // 代表传统的GPT报告
              wholeGameInfo={wholeGameInfo}
              gameInfo={gameInfo}
              scrolling={scrolling}
              contentRef={contentRef}
              key={activeId}
              kind={activeId}
              specialReportList={specialReportList}
              handleKindOnchange={(value) => {
                if (Array.isArray(value) && value.length > 0) {
                  const curTabs = [];

                  if (value.includes('1')) {
                    curTabs.push({
                      id: '1',
                      label: 'Daily Report',
                    });
                  }

                  if (value.includes('2')) {
                    curTabs.push({
                      id: '2',
                      label: 'Steam Reviews Summary',
                    });
                  }

                  if (specialReportList) {
                    curTabs.push(
                      ...specialReportList.map((item) => ({
                        id: item.activeId,
                        label: item.text,
                      })),
                    );
                  }

                  setTabs(curTabs);
                  const ids = curTabs.map((item) => item.id);
                  if (
                    (!ids.includes(activeId) || !activeId) &&
                    ids.length > 0
                  ) {
                    setActiveId(ids[0]);
                  }
                }
              }}
            ></Preview>
          </ContentBody>
        </Content>
      </Body>
    </Layout>
  );
}

export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
    listMenu: opinionCommon.listMenu,
  };
})(Gpt);
